<script setup lang="ts">
import { ref, watch } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';

const props = defineProps<{
  buildings: [];
  buildingsOrganization: [];
}>();

const emit = defineEmits([EMIT.CANCEL, EMIT.SAVE]);

const visible = ref(true);
const selectedBuildings = ref<[]>([]);

watch(
  () => [props.buildings, props.buildingsOrganization],
  ([newBuildings, newBuildingsOrg]) => {
    if (!newBuildings?.length || !newBuildingsOrg?.length) return;
    selectedBuildings.value = newBuildingsOrg.filter((org) => newBuildings.some((b) => b.building_id === org.id));
  },
  { immediate: true, deep: true },
);

watch(visible, (val) => {
  if (!val) emit(EMIT.CANCEL);
});

const submit = () => {
  const attached = selectedBuildings.value.map((b) => b.id);
  const initial = props.buildings.map((b) => b.building_id);
  const detached = initial.filter((id) => !attached.includes(id));

  emit(EMIT.SAVE, { attached, detached });
};
</script>

<template>
  <Dialog
    v-model:visible="visible"
    modal
    header="Add Building"
    :closable="true"
    style="width: 500px"
    :draggable="false"
  >
    <DataTable
      v-model:selection="selectedBuildings"
      :value="props.buildingsOrganization"
      data-key="id"
      selection-mode="multiple"
      responsive-layout="scroll"
      :sort-field="'name'"
      :sort-order="1"
    >
      <template v-if="props.buildingsOrganization.length > 0">
        <Column selection-mode="multiple" header-style="width:3rem" />
        <Column field="name" header="Name" sortable>
          <template #body="{ data }">{{ data.name }}</template>
        </Column>
      </template>
      <template #empty>Buildings not assigned.</template>
    </DataTable>

    <template #footer>
      <AppButton text="Cancel" type="secondary" @click="$emit(EMIT.CANCEL)" />
      <AppButton text="Save" type="primary" @click="submit" />
    </template>
  </Dialog>
</template>
